import { render, staticRenderFns } from "./wsuHrStructurePermissionsSelector.vue?vue&type=template&id=ba81f080&scoped=true&"
import script from "./wsuHrStructurePermissionsSelector.vue?vue&type=script&lang=js&"
export * from "./wsuHrStructurePermissionsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba81f080",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})
